import { render, staticRenderFns } from "./MobileStudentLayout.vue?vue&type=template&id=07a62d66&scoped=true"
import script from "./MobileStudentLayout.vue?vue&type=script&lang=js"
export * from "./MobileStudentLayout.vue?vue&type=script&lang=js"
import style0 from "./MobileStudentLayout.vue?vue&type=style&index=0&id=07a62d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a62d66",
  null
  
)

export default component.exports